import React from 'react';
import AMV2AssetSelector from './AMV2AssetSelector';
import cbModal from '../Modal/Modal';
import { ModalProps } from '../Modal/Modal';
import { AMV2AssetPickerArgs } from './utils/types';

const openAMV2ChooseAssetModal = (args: AMV2AssetPickerArgs, modalProps: ModalProps) => {
  const enhancedModalProps = {
    ...modalProps,
    customClass: modalProps?.customClass
      ? modalProps.customClass
      : 'AssetFieldModal-wide-popup V2-select-wide-popup'
  };

  cbModal({
    component: props => (
      <AMV2AssetSelector
        {...props}
        {...args}
      />
    ),
    modalProps: enhancedModalProps
  });
}

export default openAMV2ChooseAssetModal;